module.exports = __webpack_public_path__ + "static/media/trade-credits-icon.071fe325.svg";